<template>
    <div class="layout-header-menu"  v-bind:style ="{ height: headerHeight}">
        <el-menu class="user_info_cla" mode="horizontal" @select="handleSelect">
            <el-submenu index="2" class="submenu_cla">
                <template slot="title">
                    {{loginName}}
                    <i class="zk-icon-users"></i>
                </template>
                <el-menu-item index="modifyPwd">
                  <slot name="modifyPwd">
                    {{$t('account.modifyPwd')}}
                  </slot>
                </el-menu-item>
                <el-menu-item index="loginout">
                  <slot name="loginout">
                    {{$t('account.loginOut')}}
                  </slot>
                </el-menu-item>
            </el-submenu>
        </el-menu>
        <zk-modify-pwd @close="dialogVisible=false" :dialogVisible="dialogVisible"></zk-modify-pwd>
    </div>
</template>
<script>
import {loginout} from '../../../services/user.js'
export default {
  name: 'ZkUserInfo',
  data () {
    return {
      loginName: '',
      dialogVisible: false
    }
  },
  props: {
    headerHeight: {
      type: String,
      default: '60px'
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      if (key === 'loginout') {
        loginout()
      }
      if (key === 'modifyPwd') {
        this.dialogVisible = true
      }
    }
  },
  mounted () {
    this.loginName = window.localStorage.getItem('loginName') || ''
  }
}
</script>
<style lang="less">
 .layout-header-menu{
     position: absolute;
     right: 0px;
     top: 0px;
     height: 100%;
    .user_info_cla{
        background-color: transparent;
        height: 100%;
        .submenu_cla{
           height: 50px;
           color: white;
           background-color: transparent;
          .el-submenu__title{
            background-color: transparent;
            height: 100%;
            color: white;
            line-height: 50px;
          }
        }

    }
 }
</style>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/loginUserInfo/src/main.vue